import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "darken-on-hover" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons-outlined" }, " calendar_today ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons-outlined" }, " close ", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-sm font-light text-danger-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
				'border-danger-dark focus-within:border-danger-dark': _ctx.$slots.errors,
			}, "relative z-10 border-b-2 border-gray-200 bg-light w-max"])
    }, [
      _createVNode(_component_date_picker, {
        class: "z-10 bg-transparent calendar-floating-label",
        onOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpen())),
        open: _ctx.calendarOpen,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClose())),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus'))),
        value: _ctx.proxyModelValue,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.proxyModelValue) = $event)),
        type: "datetime",
        ref: 'calendar-' + _ctx.elementId,
        "show-second": false,
        formatter: _ctx.momentFormat,
        "title-time-format": 'DD-MM-YYYY',
        shortcuts: _ctx.shortcuts
      }, {
        "icon-calendar": _withCtx(() => [
          _hoisted_2
        ]),
        "icon-clear": _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["open", "value", "formatter", "shortcuts"]),
      _createElementVNode("label", {
        class: _normalizeClass(["absolute left-1.5 origin-0 -z-1", {
					'calendar-fixed-label': _ctx.proxyModelValue != null || _ctx.calendarOpen,
					'bottom-1.5': _ctx.proxyModelValue == null,
				}])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2),
    (_ctx.$slots.errors?.())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "errors")
        ]))
      : _createCommentVNode("", true)
  ]))
}